/**
 * Schedule Animation Callback
 *
 * A small utility wrapper around window.requestAnimationFrame
 * to support running the callback immediately in non-document environments
 *
 * @module    schedule-animation-callback
 * @author    Matthew Hamlin <mhamlin@wayfair.com>
 * @copyright 2018 Wayfair LLC - All rights reserved
 */

const scheduleAnimationCallback = (callback) =>
  typeof window !== 'undefined' &&
  typeof window.requestAnimationFrame === 'function'
    ? window.requestAnimationFrame(callback)
    : callback();

export default scheduleAnimationCallback;
